import { useEffect, useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { useSession } from '@/context/session-context';

const navigation = [
  {
    label: 'Platform',
    items: [
      { to: '/', label: 'Overview', icon: '◫' },
      { to: '/search', label: 'Global search', icon: '⌕' },
      { to: '/users', label: 'Users', icon: '○' },
      { to: '/businesses', label: 'Businesses', icon: '◇' },
      { to: '/prospects', label: 'Prospects', icon: '◎' },
      { to: '/dictionary', label: 'Dictionary', icon: 'あ' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { to: '/bookings', label: 'Bookings', icon: '▣' },
      { to: '/subscriptions', label: 'Subscriptions', icon: '¤' },
      { to: '/moderation', label: 'Moderation', icon: '!' },
    ],
  },
  {
    label: 'Diagnostics',
    items: [
      { to: '/communications', label: 'Chat & calls', icon: '◌' },
      { to: '/system', label: 'System health', icon: '⌁' },
      { to: '/audit', label: 'Audit log', icon: '≡' },
    ],
  },
];

export function AppShell() {
  const { staffSession, signOut } = useSession();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        navigate('/search');
        requestAnimationFrame(() => document.querySelector<HTMLInputElement>('[data-global-search]')?.focus());
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [navigate]);

  return (
    <div className="app-shell">
      <button className="mobile-menu" onClick={() => setMobileOpen((value) => !value)} aria-label="Toggle navigation">☰</button>
      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="brand">
          <span className="brand-mark">e</span>
          <div><strong>Everyvisit</strong><span>Admin platform</span></div>
        </div>
        <button className="command-button" onClick={() => navigate('/search')}>
          <span>⌕</span> Search everything <kbd>⌘ K</kbd>
        </button>
        <nav>
          {navigation.map((section) => (
            <div className="nav-section" key={section.label}>
              <span className="nav-label">{section.label}</span>
              {section.items.map((item) => (
                <NavLink key={item.to} to={item.to} end={item.to === '/'} onClick={() => setMobileOpen(false)}>
                  <span className="nav-icon">{item.icon}</span>{item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          {staffSession?.staff.role === 'platform_admin' ? <NavLink to="/staff">Staff access</NavLink> : null}
          <div className="staff-card">
            <span className="avatar">{staffSession?.user.email?.slice(0, 1).toUpperCase() ?? 'A'}</span>
            <div>
              <strong>{staffSession?.staff.display_name || staffSession?.user.email}</strong>
              <span>{staffSession?.staff.role.replace(/_/g, ' ')}</span>
            </div>
            <button onClick={() => void signOut()} title="Sign out">↪</button>
          </div>
        </div>
      </aside>
      <main className="main-content"><Outlet /></main>
    </div>
  );
}
